<!--
@Author: MIYONGLE
@Desc: 解决方案-地产行业
@Date: 2021-07-28 13时
-->
<template>
  <div class="page-main">
    <!-- 顶部 -->
    <mMenusNav><span>{{ titleName }}</span></mMenusNav>
    <!-- 背景 -->
    <div class="banner-box">
      <p class="title">
        <span>房地产行业</span><br>
        <span>解决方案</span>
      </p>
      <p class="full-btn" @click="opearMth">立即咨询</p>
    </div>
    <!-- 环境预见 -->
    <div class="foresight">
      <div class="title-txt">环境预见</div>
      <div class="foresight-hyhj">
        <!-- 行业大环境 -->
        <div class="section-item first">
          <div class="top-img" @mouseenter="mouseenterFn('first')">
            <div class="unactive-item" :class="activeClassName == 'first' ? 'active':'unactive'">
              <div class="content">
                <p class="title">行业大环境</p>
                <p class="text">未来房地产总数量规模会被控制在一个很小的范围</p>
              </div>
            </div>
            <div class="active-item" :class="activeClassName == 'first' ? 'unactive':'active'">
              <div class="content">
                <p class="title">行业大环境</p>
                <img src="../../../static/mobile/msolution/icon_open.png" alt="">
              </div>
            </div>
          </div>
          <!-- <div class="wrap" :class="activeClassName == 'first' ? 'active':'unactive'"> -->
          <div class="wrap">
            <div class="centext-box">
              <p class="title">房企</p>
                <div class="text-content">
                  <p class=txt-item>TOP5的房企销售金额占总体规模市场约15%，TOP30房企占比约35%，且逐年递增（TOP5车企51%；空调品牌78%；手机品牌83%）</p>
                  <p class=txt-item>未来房企数量较大概率会控制在较小范围</p>
                  <p class=txt-item>头部房企未来会进一步抢占腰部及以下房企的市场份额</p>
                  <p class=txt-item>过去企业依赖大幅度增加负债的增长模式在未来生存空间会越来越小。加快去化，加快销售变现，降低企业负债率会成为主流</p>
                </div>
                <p class="slider"></p>
                <p class="title">销售</p>
                <div class="text-content">
                  <p class=txt-item>市场上多个熟知的销售渠道在若干年与企业合作过程中逐年迅速发展壮大，当年屠龙的少年在很多房企老板眼里已经变成了“恶龙”</p>
                  <p class=txt-item>部分房企的销售渠道被第三方完全掌控，而企业也是饮鸩止渴，恶性循环导致企业自己的话语权逐年减弱。企业营销预算被第三方全部拿走，也导致企业本身的营销能力越来越弱</p>
                </div>
            </div>
          </div>
        </div>

        <!-- 企业环境 -->
        <div class="section-item second">
          <div class="top-img" @mouseenter="mouseenterFn('second')">
            <div class="unactive-item2" :class="activeClassName == 'second' ? 'active':'unactive'">
              <div class="content">
                <p class="title">企业环境</p>
                <p class="text">在未来争存量白热化的市场环境下，完全依赖第三方包销渠道的部分房企项目如果为了争抢当地固定存量市场客户，第三方渠道收费方式和收费费率也必然进一步水涨船高</p>
              </div>
            </div>
            <div class="active-item" :class="activeClassName == 'second' ? 'unactive':'active'">
              <div class="content">
                <p class="title">企业环境</p>
                <img src="../../../static/mobile/msolution/icon_open.png" alt="">
              </div>
            </div>
          </div>
          <!-- <div class="wrap" :class="activeClassName == 'second' ? 'active':'unactive'"> -->
          <div class="wrap">
            <div class="centext-box2">
              <p class="title">政策</p>
                <div class="text-content">
                  <p class=txt-item>中国房地产行业从2019年进入分水岭，中央调控政策，房地产总体规模会保持很多年，不会有明显增量</p>
                  <p class=txt-item>房企从过去抢增量市场到明年开始争存量市场</p>
                  <p class=txt-item>2020年年中，中央出台“三道红线” ，以及12月31日央行出台的“银行金融机构房地产贷款集中管理”等调控新规，使分水岭更加具象化</p>
                  <p class=txt-item>过去企业依赖大幅度增加负债的增长模式在未来生存空间会越来越小。加快去化，加快销售变现，降低企业负债率会成为主流</p>
                </div>
                <p class="slider"></p>
                <p class="title">行业</p>
                <div class="text-content">
                  <p class=txt-item>平均目标增长率由 2018 年的 41% 回落至 20% ，去化率不及预期</p>
                  <p class=txt-item>受调控持续、市场整体去化率不及预期，房企的目标完成率呈逐年降低的态势。相比2016年、2017年近80%房企目标完成率超110%，2019年该区间的房企数量明显降低，全年仅50%房企目标完成率集中在100%-110% 之间</p>
                  <p class=txt-item>2020年top30房企，仅8成完成年度目标</p>
                </div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <!-- 房地产行业解决方案 -->
    <div class="solution">
      <div class="title-txt">房地产行业解决方案</div>
      <div class="text-content">
        <div class="title">
          全民营销服务+灵活用工模式
        </div>
        <p class=txt-item>
          慧用工作为新业态新经济灵活用工平台，与地产企业建立平台综合服务协议，给企业提供全民营销服务
        </p>
        <p class=txt-item>
          慧用工与企业内外的地产经济人签署相应的电子服务合同，帮助企业销售
        </p>
        <p class=txt-item>
          慧用工为企业提供票据凭证
        </p>
        <p class=txt-item>
          地产经济人的服务佣金，由慧用工平台统一发放，统一申报个税
        </p>
      </div>
      <img class="text-img" src="../../../static/mobile/msolution/img_solution_31.png" alt="">
    </div>
    <!-- 房地产行业解决方案 -->
    <div class="advantage">
      <div class="title">我们的优势</div>
      <van-swipe class="my-swipe" :autoplay="4000" indicator-color="white"  @change="onChange">
        <van-swipe-item v-for="item in ourAdvantage" :key="item.titleName"> 
          <div class="title-name">{{item.titleName}}</div>
          <div class="txt-item">{{item.txt1}}</div>
          <div class="txt-item">{{item.txt2}}</div>
          <div class="txt-item">{{item.txt3}}</div>
          <div class="txt-item">{{item.txt4}}</div>
        </van-swipe-item>
        <template #indicator >
          <div :class="slide=='0'?'custom-indicator1':'uncustom-indicator1'">
          </div>
          <div :class="slide=='1'?'custom-indicator2':'uncustom-indicator2'">
          </div>
          <div :class="slide=='2'?'custom-indicator3':'uncustom-indicator3'">
          </div>
          <div :class="slide=='3'?'custom-indicator4':'uncustom-indicator4'">
          </div>
          <div :class="slide=='4'?'custom-indicator5':'uncustom-indicator5'">
          </div>
        </template>
      </van-swipe>
      <div class="footer-txt">助力营销赋能，加快销售回款；回归真实业务，降低企业成本。</div>
    </div>

    <!-- 合作案例 -->
    <div class="cooperation">
      <div class="title">合作案例</div>
      <div class="text-content">
        <div class="subtitle">长隆、景盛、坤达地产</div>
        <div class=txt-item>
          <div class="top-title">降低财务风险</div>
          <div class="bottom-txt">企业进行全民营销活动，帮助企业给个人结算的佣金实现账务合规，有增值税专用 发票可抵扣。</div>
        </div>
        <div class=txt-item>
          <div class="top-title">降低企业成本8%</div>
          <div class="bottom-txt">全民营销模式+慧用工解决方案，降低企业用工成本。每月为企业节省单人4900元用工成本，节省8%的用工成本</div>
        </div>
        <div class=txt-item>
          <div class="top-title">个人收入提升33%</div>
          <div class="bottom-txt">单个项目为个人提高收入1万余元左右</div>
        </div>
      </div>
      <img class="text-img" src="../../../static/mobile/msolution/img_solution_case.png" alt="">

    </div>

    <!-- form弹窗 -->
    <mFrom :source='source'></mFrom>
  </div>
</template>

<script type="text/javascript">
import mMenusNav from "../../components/mMenusNav";
import mFrom from "../../components/mFrom";
import {OUR_ADVANTAGE} from "../../service/businessConsts";
export default {
  name: "app",
  data() {
    return {
      source: '',
      titleName: "房地产行业",
      activeClassName:'first',
      ourAdvantage:OUR_ADVANTAGE,
      slide:0,
    }
  },
  components: {
    mMenusNav: mMenusNav,
    mFrom: mFrom,
  },
  created() {
    // source来源：：
    let hash = window.location.hash;
    this.source = hash.indexOf('source') > 0 ? hash.substring(hash.indexOf('source')) + '&pageFrom=mjjfa_dchy' : '&pageFrom=mjjfa_dchy';
  },
  methods: {
    opearMth(){
      eventBus.$emit("operaDiaLog", true);
    },

    mouseenterFn(className){
      this.activeClassName = className;
      let firstDom = document.querySelector('.first .centext-box')
      let secondDom = document.querySelector('.second .centext-box2')
      if(className == 'first'){
        firstDom.style.height = '11.67rem'
        secondDom.style.height = '0px'

        firstDom.style.opacity = '1'
        secondDom.style.opacity = '0'

        firstDom.style.transition = 'all 0.8s'

      } else if(className == 'second'){
        secondDom.style.height = '11.67rem'
        firstDom.style.height = '0px'
        secondDom.style.opacity = '1'
        firstDom.style.opacity = '0'
        secondDom.style.transition = 'all 0.8s'
      }
    },

    onChange(index){
      this.slide=index;
    }
  }
}
</script>

<style lang="scss" scoped>
.banner-box{
  width: 100%;
  height: 1080px;
  overflow: hidden;
  background-image: url(../../../static/mobile/msolution/banner_solution_3.png);
  // background-repeat:no-repeat;
  background-color: #100f0f;
  background-size:100%;
  .title{
    margin: 0 auto;
    margin-top: 463px;
    text-align: center;
    // width: 622px;
    height: 152px;
    font-size: 60px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #FFFFFF;
    line-height: 76px;
  }
  .full-btn{
    margin:0 auto;
    margin-top: 66px;
    width: 288px;
    height: 80px;
    background: #1985FF;
    border-radius: 40px;
    text-align: center;
    font-size: 30px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 80px;
  }
}

.foresight{
  margin: 0 auto;
  width: 100%;
  // width: 750px;
  overflow: hidden;
  background-color: #FBFDFF;
  .title-txt{
    margin: 70px auto 36px;
    // width: 160px;
    height: 56px;
    font-size: 40px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #100F0F;
    line-height: 56px;
  }
  .foresight-hyhj{
    .section-item{
      width:auto;
      .top-img{
        width: 690px;
        overflow: hidden;
        margin:0 auto;
        text-align: center;
        .unactive-item{
          background-image: url('../../../static/mobile/msolution/img_solution_hangye1.png');
          background-size: 100%;
          overflow: hidden;
          .content{
            height: 240px;
            overflow: hidden;
            opacity: 0.8;
            .title{
              margin-top: 69px;
              font-size: 32px;
              // font-family: AlibabaPuHuiTiM;
              color: #FFFFFF;
              line-height: 44px;
            }
            .text{
              width: 620px;
              margin: 0 auto;
              margin-top: 19px;
              font-size: 22px;
              // font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #FFFFFF;
              line-height: 32px;
            }
          }
        }
        .unactive-item2{
          background-image: url('../../../static/mobile/msolution/img_solution_hangye2.png');
          background-size: 100%;
          overflow: hidden;
          .content{
            height: 240px;
            overflow: hidden;
            .title{
              margin-top: 69px;
              font-size: 32px;
              // font-family: AlibabaPuHuiTiM;
              color: #FFFFFF;
              line-height: 44px;
            }
            .text{
              width: 620px;
              margin: 0 auto;
              margin-top: 19px;
              font-size: 22px;
              // font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #FFFFFF;
              line-height: 32px;
            }
          }
        }
        .active{
          display: block;
        }
        .unactive{
          display: none;
        }
        .active-item{
          overflow: hidden;
          // display: none;
          background-image: url('../../../static/mobile/msolution/img_solution_hangye1.png');
          background-size: 100%;
          .content{
            height: 240px;
            background-color: #002979;
            opacity: 0.8;
            overflow: hidden;
            .title{
              margin-top: 79px;
              font-size: 32px;              
              // font-family: AlibabaPuHuiTiM;
              color: #FFFFFF;
              line-height: 44px;
            }
            img{
              margin:0 auto;
              margin-top: 9px;
              width: 42px;
              height: 42px;
            }
          }
        }
      }
      .active{
        display: block;
      }
      .unactive{
        display: none;
      }
      .wrap{
        margin:0 auto;
        width: 690px;
        overflow: hidden;
        background: #FFFFFF;
        box-shadow: 0px 20px 60px -20px rgba(0, 0, 0, 0.1);
        .centext-box{
          width: 590px;
          height: 875px;
          opacity: 1;
          overflow: hidden;
          margin: 0 auto;
          text-align: left;
          .title{
            margin-top:32px;         
            font-size: 28px;
            // font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #403F3F;
            line-height: 40px;
          }
          .txt-item{
            margin-top: 20px;
            font-size: 22px;
            // font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #100F0F;
            line-height: 30px;
            background: url('./../../../static/pc/解决方案/icon_sign_blue.png') no-repeat;
            background-position: 0px 0px;
            background-size:28px;
            padding-left: 44px;
          }
          .slider{
            margin-top: 32px;
            width: 590px;
            height: 1px;
            background-color: #CFCFCF;
          }
        }
        .centext-box2{
          width: 590px;
          height: 0;
          opacity: 0;
          overflow: hidden;
          margin: 0 auto;
          text-align: left;
          .title{
            margin-top:32px;         
            font-size: 28px;
            // font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #403F3F;
            line-height: 40px;
          }
          .txt-item{
            margin-top: 20px;
            font-size: 22px;
            // font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #100F0F;
            line-height: 30px;
            background: url('./../../../static/pc/解决方案/icon_sign_blue.png') no-repeat;
            background-position: 0px 0px;
            background-size:28px;
            padding-left: 44px;
          }
          .slider{
            margin-top: 32px;
            width: 590px;
            height: 1px;
            background-color: #CFCFCF;
          }
        }

      } 
    }
  }
}

.solution{
  margin:0 auto;
  // width: 750px;
  width: 100%;
  height: 993px;
  background-color: #FBFDFF;
  overflow: hidden;
  .title-txt{
    margin-top: 102px;
    font-size: 40px;
    // font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #100F0F;
    line-height: 56px;
  }
  .text-content{
    width: 590px;
    height: 373px;
    margin: 0 auto;
    margin-top: 54px;
    .title{
      margin: 0 auto 3px;
      text-align: center;
      // width: 405px;
      height: 40px;
      font-size: 28px;
      // font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #403F3F;
      line-height: 40px;
    }
    .txt-item{
      background: url('./../../../static/pc/解决方案/icon_sign_blue.png') no-repeat;
      background-position: 0px 0px;
      background-size:28px;
      padding-left: 44px;
      margin-top: 22px;
      text-align: left;
      font-size: 22px;
    }
  }
  .text-img{
    margin:0 auto;
    width: 690px;
    height: 343px;
  }
}

.advantage{
  margin:0 auto;
  // width: 750px;
  width: 100%;
  height: 616px;
  overflow: hidden;
  background: #171E2E;
  .title{
    margin: 48px auto 56px;
    // width: 200px;
    height: 56px;
    font-size: 40px;
    // font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #FFFFFF;
    line-height: 56px;
  }
  .my-swipe{
    margin:0 auto;
    width: 584px;
    height: 280px;
    // background-color: rgb(156, 86, 86);s
    .title-name{
      margin:0 auto 15px;
      // width: 112px;
      height: 40px;
      font-size: 28px;
      // font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #FFFFFF;
      line-height: 40px;
    }
    .txt-item{
      background: url('./../../../static/pc/解决方案/icon_sign_blue.png') no-repeat;
      background-position: 0px 0px;
      background-size:28px;
      padding-left: 44px;
      margin-bottom: 24px;
      text-align: left;
      font-size: 22px;
      color: #FFF;
    }
    .custom-indicator1{
      position: absolute;
      bottom: 0;
      left: 130px;
      width: 60px;
      height: 4px;
      float: left;
      background: #1985FF;
      border-radius: 6px;
    }
    .uncustom-indicator1{
      position: absolute;
      bottom: 0;
      left: 130px;
      width: 60px;
      height: 4px;
      float: left;
      opacity: 0.09;
      background: #FFF;
      border-radius: 6px;
    }
    .custom-indicator2{
      position: absolute;
      bottom: 0;
      left: 196px;
      width: 60px;
      height: 4px;
      float: left;
      background: #1985FF;
      // opacity: 0.09;
      border-radius: 6px;
    }
    .uncustom-indicator2{
      position: absolute;
      bottom: 0;
      left: 196px;
      width: 60px;
      height: 4px;
      float: left;
      background: #FFF;
      opacity: 0.09;
      border-radius: 6px;
    }
    .custom-indicator3{
      position: absolute;
      bottom: 0;
      left: 262px;
      width: 60px;
      height: 4px;
      float: left;
      background: #1985FF;
      // opacity: 0.09;
      border-radius: 6px;
    }
    .uncustom-indicator3{
      position: absolute;
      bottom: 0;
      left: 262px;
      width: 60px;
      height: 4px;
      float: left;
      background: #FFF;
      opacity: 0.09;
      border-radius: 6px;
    }
    .custom-indicator4{
      position: absolute;
      bottom: 0;
      left: 328px;
      width: 60px;
      height: 4px;
      float: left;
      background: #1985FF;
      border-radius: 6px;
    }
    .uncustom-indicator4{
      position: absolute;
      bottom: 0;
      left: 328px;
      width: 60px;
      height: 4px;
      float: left;
      opacity: 0.09;
      background: #FFF;
      border-radius: 6px;
    }
    .custom-indicator5{
      position: absolute;
      bottom: 0;
      left: 394px;
      width: 60px;
      height: 4px;
      float: left;
      background: #1985FF;
      border-radius: 6px;
    }
    .uncustom-indicator5{
      position: absolute;
      bottom: 0;
      left: 394px;
      width: 60px;
      height: 4px;
      float: left;
      opacity: 0.09;
      background: #FFF;
      border-radius: 6px;
    }
  }
  .footer-txt{
    margin:0 auto;
    margin-top: 56px;
    width: 308px;
    height: 76px;
    font-size: 22px;
    // font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 38px;
  }
}

.cooperation{
  margin: 0 auto;
  width: 750px;
  height: 1254px;
  overflow: hidden;
  background: #FBFDFF;
  .title{
    margin-top: 102px;
    font-size: 40px;
    // font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #100F0F;
    line-height: 56px;
  }
  .text-content{
    margin:0 auto;
    background-color: #fff;
    width: 594px;
    height: 450px;
    overflow: hidden;
    .subtitle{
      margin-top: 53px;
      font-size: 28px;
      // font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #403F3F;
      line-height: 40px;
    }
    .txt-item{
      margin-top: 20px;
      font-size: 22px;
      text-align: left;
      // font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #100F0F;
      line-height: 30px;
      background: url('./../../../static/pc/解决方案/icon_sign_blue.png') no-repeat;
      background-position: 0px 0px;
      background-size:28px;
      padding-left: 44px;
      .top-title{
        font-weight: 500;
        // font-family: AlibabaPuHuiTiM;
        color: #403F3F;
        line-height: 30px;
      }
      .bottom-txt{
        margin-top: 10px;
        width: 546px;
        // font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #403F3F;
        line-height: 30px;
      }
    }    
  }
  .text-img{
    margin: 0 auto;
    margin-top: 32px;
    width: 690px;
    height: 480px;
  }
}

</style>


// WEBPACK FOOTER //
// src/views/mobile/mSolution_property.vue